(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lumora-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('havren-header')) {
  customElements.define('havren-header', class HavrenHeader extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const groups = Array.from(this.querySelectorAll('.lumora-header__nav-group'));
      const mobileMenu = this.querySelector('.lumora-header__mobile-menu');
      const hoverEnabled = window.matchMedia('(hover: hover) and (pointer: fine)');

      const closeGroups = (except) => {
        groups.forEach((group) => {
          if (group !== except) group.removeAttribute('open');
        });
      };

      const closeAll = () => {
        closeGroups();
        mobileMenu?.removeAttribute('open');
      };

      groups.forEach((group) => {
        let openTimer;
        let closeTimer;

        group.addEventListener('toggle', () => {
          if (group.open) {
            closeGroups(group);
            mobileMenu?.removeAttribute('open');
          }
        }, { signal });

        group.addEventListener('pointerenter', () => {
          if (!hoverEnabled.matches) return;
          window.clearTimeout(closeTimer);
          openTimer = window.setTimeout(() => group.setAttribute('open', ''), 70);
        }, { signal });

        group.addEventListener('pointerleave', () => {
          if (!hoverEnabled.matches) return;
          window.clearTimeout(openTimer);
          closeTimer = window.setTimeout(() => group.removeAttribute('open'), 180);
        }, { signal });
      });

      mobileMenu?.addEventListener('toggle', () => {
        if (mobileMenu.open) closeGroups();
      }, { signal });

      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) closeAll();
      }, { signal });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        closeAll();
        this.querySelector('.lumora-header__nav-group[open] > summary, .lumora-header__mobile-menu[open] > summary')?.focus();
      }, { signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
